<app-circular-selection [options]="subtenantData" (onClickAction)="clicked($event)">
  <div heading>
    <div>
      Who brought you to <span class="tenantMobileName">{{tenantName}}?</span>
    </div>
    <div class="tenantName">
      {{tenantName}}?
    </div>
  </div>
</app-circular-selection>
